<c-row class="gap-2 mt-3 mb-3">
  <!-- <c-col class="form-group">
        <label for="date-range">Date Range</label>
        <input type="text" placeholder="Search registration..." />
    </c-col> -->
  <c-col class="form-group">
    <label for="date-range">Date Range</label>
    <select id="date-range" class="form-control" [(ngModel)]="selectedFilterValues.selectedDateRangeName" required
      cSelect (ngModelChange)="onSelectedFilterValuesChange()">
      <option *ngFor="let option of dateRanges" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  </c-col>

  <c-col class="form-group">
    <label for="region">Region</label>
    <select id="region" class="form-control" required cSelect [(ngModel)]="selectedFilterValues.selectedRegion" (ngModelChange)="onSelectedFilterValuesChange()">
      <option [value]= "''" >Select a Region</option>
      <option *ngFor="let option of regions" [value]="option.id"
        [selected]="option === selectedFilterValues.selectedRegion">
        {{ option.name }}
      </option>
    </select>
  </c-col>

  <c-col class="form-group" *ngIf="depots">
    <label for="depots">Depots</label>
    <select id="depots" class="form-control" required cSelect [(ngModel)]="selectedFilterValues.selectedDepot" (ngModelChange)="onSelectedFilterValuesChange()">
      <option [value]= "''">Select a Depot</option>
      <option *ngFor="let option of depots" [value]="option.id" [selected]="option === selectedFilterValues.selectedDepot">
        {{ option.name }}
      </option>
    </select>
  </c-col>
<!-- 
  <c-col class="form-group">
    <label for="vehicle-types">Vehicle Types</label>
    <select id="vehicle-types" class="form-control" required cSelect
      [(ngModel)]="selectedFilterValues.selectedVehicleType">
      <option value="VAN">Van</option>
      <option value="MTRUCK">Medium Truck</option>
    </select>
  </c-col>

  <c-col class="form-group">
    <label for="fuel-types">Fuel Types</label>
    <select id="fuel-types" class="form-control" required cSelect [(ngModel)]="selectedFilterValues.selectedFuelType">
      <option value="diesel">Diesel</option>
      <option value="petrol">Petrol</option>
      <option value="electric">Electric</option>

    </select>
  </c-col> -->
</c-row>
